import React, { useContext, useEffect, useState } from "react";
import { Button, MenuItem } from "@chakra-ui/react";
import { faArrowsToCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContentContext from "../../../common/context/ContentContext";
import { SizeAwareComponent } from "../../../store/types";

interface OwnProps extends SizeAwareComponent {
    onLinkContent: () => void;
    mode?: "button" | "menu-item"
}

const RelatedContentButton = ({
    onLinkContent,
    mode,
    isMinimumSize
}: OwnProps) => {
    const content = useContext(ContentContext);
    const [text, setText] = useState("");
    useEffect(() => {
        let _text = "Contenido Relacionado";
        if (content) {
            _text += content.relationships.length > 0 ? ` (${content.relationships.length})` : "";
        }

        setText(_text);
    }, [content]);

    return (
        <>
            {mode === "menu-item" ?
                <MenuItem onClick={onLinkContent} icon={<FontAwesomeIcon icon={faArrowsToCircle} />}>
                    Contenido Relacionado
                </MenuItem> :
                <Button
                    colorScheme="telegram"
                    variant="outline"
                    leftIcon={<FontAwesomeIcon icon={faArrowsToCircle} />}
                    onClick={onLinkContent}
                    iconSpacing={isMinimumSize ? 1 : 0}
                    title={text}
                >
                    {isMinimumSize ? "Contenido Relacionado":""}
                </Button>
            }
        </>
    );
};

export default RelatedContentButton;
